import {cancelCircleSvg as Icon__small__cancelCircleSvg} from '../Icon__small/Icon__small--cancelCircle.js'

export var cancelCircle = {
  name: 'cancelCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cancelCircleSvg,
};
